import { useTranslation } from 'react-i18next';

import { CollaborationState } from '@/signalr';
import type { CollaborationStateHistoryRecord } from '@/signalr';
import { DateFormatter } from '@/features/shared/DateFormatter';

export type InvolvedPsapCollaborationStateBadgeProps = {
  currentState: CollaborationStateHistoryRecord;
};

export function InvolvedPsapCollaborationStateBadge({ currentState }: InvolvedPsapCollaborationStateBadgeProps) {
  const { t } = useTranslation();

  const showBadge =
    currentState.state === CollaborationState.Requested ||
    currentState.state === CollaborationState.Confirmed ||
    currentState.state === CollaborationState.Rejected;

  if (!showBadge) {
    return null;
  }

  const effectiveBadgeClass =
    currentState.state === CollaborationState.Requested
      ? 'bg-warning-subtle px-1 rounded-2'
      : currentState.state === CollaborationState.Confirmed
        ? 'bg-success-subtle px-1 rounded-2'
        : 'bg-danger-subtle px-1 rounded-2';

  const effectiveBadgeIcon =
    currentState.state === CollaborationState.Requested
      ? 'fal fa-question-circle'
      : currentState.state === CollaborationState.Confirmed
        ? 'fal fa-check-circle'
        : 'fal fa-times-circle';

  const collaborationStateText =
    currentState.state === CollaborationState.Requested
      ? t('Incident_InvolvedPsapStateAction_Invited')
      : currentState.state === CollaborationState.Confirmed
        ? t('Incident_InvolvedPsapState_Confirmed')
        : t('Incident_InvolvedPsapState_Rejected');

  return (
    <div className={`${effectiveBadgeClass} row justify-content-between lh-1 mt-1 py-1`}>
      <span className="text-nowrap small text-muted w-auto">
        <i className={`${effectiveBadgeIcon} me-1`}></i>
        {collaborationStateText}
      </span>
      <span className="text-nowrap small w-auto">
        <DateFormatter date={currentState.timestampUtc} updateIntervalMs={1000} formatType="calendar" />
      </span>
    </div>
  );
}
